<template>
  <el-select
    :disabled="disabled || !provinceId"
    :style="{ width: width }"
    size="small"
    clearable
    filterable
    placeholder="请选择城市"
    v-model="resultValue"
    @change="onChange"
  >
    <el-option
      v-for="item in cityList"
      :key="item.id"
      :label="item.name"
      :value="item.id"
    >
    </el-option>
  </el-select>
</template>

<script>
import { getCity } from './api'
export default {
  name: 'SelectCity',

  props: {
    value: {
      type: [String, Number],
      default: ''
    },
    provinceId: {
      type: [String, Number],
      default: ''
    },
    width: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    resultValue: {
      get() {
        return this.value
      },

      set(val) {
        this.$emit('input', val)
      }
    }
  },

  data() {
    return {
      cityList: []
    }
  },

  watch: {
    provinceId: {
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          // 只有在省份被用户实际更改时才清空城市选择
          if (oldVal) {
            this.$emit('input', '')
          }
          if (newVal) {
            this.getCityList(newVal)
          } else {
            this.cityList = []
          }
        }
      },
      immediate: true
    }
  },

  methods: {
    async getCityList(provinceId) {
      if (!provinceId) {
        this.cityList = []
        this.$emit('list-loaded')
        return
      }
      try {
        const res = await getCity(provinceId)
        this.cityList = res || []
      } catch (error) {
        console.error('获取城市列表失败:', error)
        this.cityList = []
      } finally {
        this.$emit('list-loaded')
      }
    },

    onChange(val) {
      this.$emit('change', val)
      // 获取选中城市的名称
      const selectedCity = this.cityList.find(item => item.id === val)
      this.$emit('city-change', {
        id: val,
        name: selectedCity ? selectedCity.name : ''
      })
    }
  }
}
</script>

<style></style>